import {
  AggregatorPaymentSystems,
  WithdrawalsDistributionBalanceItems,
} from '@types';

import { WithdrawalsReceiveGetDistributionBalanceListReducer } from './types';

export const withdrawalsReceiveGetDistributionBalanceListReducer: WithdrawalsReceiveGetDistributionBalanceListReducer =
  (state, action) => {
    const { items } = action.payload;

    const withdrawalsDistributionBalanceItems = items.reduce(
      (previousValue, currentValue) => {
        return {
          ...previousValue,
          [currentValue.id]: {
            paymentSystems: currentValue.paymentSystems.reduce(
              (previousValue, currentValue) => {
                return currentValue
                  ? {
                      ...previousValue,
                      [currentValue.id]: {
                        id: currentValue.id,
                        balance: !currentValue.balance
                          ? null
                          : {
                              total: currentValue.balance.total,
                              balanceCurrencyCode:
                                currentValue.balance.balanceCurrencyCode,
                              lastTransactionTime:
                                currentValue.balance.lastTransactionTime,
                            },
                      },
                    }
                  : previousValue;
              },
              {} as AggregatorPaymentSystems
            ),
          },
        };
      },
      {} as WithdrawalsDistributionBalanceItems
    );

    return {
      ...state,
      withdrawalsDistributionBalanceItems,
    };
  };
